// extracted by mini-css-extract-plugin
export default {"container":"BusinessShareImage_container__+pLFo","image_container":"BusinessShareImage_image_container__ICzCK"};